import { useEffect, useState } from 'react';

/**
 * The value once it has stayed the same for `delayMs`; undefined meanwhile. Stepping through RNK-02 with
 * Previous / Next passes many people in a second, and Haiku's reason is paid for (ADR 0051 §6), so it is
 * asked for only where the sheet rests (Redesign Group 3).
 */
export function useRested<T>(value: T, delayMs: number): T | undefined {
  const [rested, setRested] = useState<{ readonly value: T } | null>(null);
  useEffect(() => {
    const timer = window.setTimeout(() => setRested({ value }), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);
  return rested !== null && Object.is(rested.value, value) ? rested.value : undefined;
}
